import { Action } from "redux";
import { Accommodation, Language, ThunkAction } from "../types/index.js";
import { fetch } from "../utils/utils.js";
import { showAlert } from "./Alerts.js";
import { isActionType } from "./utils.js";

const ActionTypeKeys = [
  "GET_ACCOMMODATION_START",
  "GET_ACCOMMODATION_SUCCESS",
  "GET_ACCOMMODATION_ERROR",
] as const;

type ActionType = (typeof ActionTypeKeys)[number];
type ActionBase<T extends ActionType> = Action<T>;

type GetAccommodationStart = ActionBase<"GET_ACCOMMODATION_START"> & {
  languageId: Language;
};
type GetAccommodationSuccess = ActionBase<"GET_ACCOMMODATION_SUCCESS"> & {
  languageId: Language;
  accommodation: Accommodation;
};
type GetAccommodationError = ActionBase<"GET_ACCOMMODATION_ERROR"> & {
  error: Error;
};

export type AccommodationAction =
  | GetAccommodationStart
  | GetAccommodationSuccess
  | GetAccommodationError;

export const isAccommodationAction = (
  action: Action,
): action is AccommodationAction => isActionType(action, ActionTypeKeys);

export const getAccommodation =
  (siteId: string, languageId: Language): ThunkAction<Promise<void>> =>
  async (dispatch, getState) => {
    const loadState = getState().loadStates.accommodation[languageId];
    if (loadState !== "unloaded" && loadState !== undefined) {
      return Promise.resolve();
    }
    dispatch(getAccommodationStart(languageId));
    try {
      const { data } = await fetch({ dispatch, languageId }).get<Accommodation>(
        `sites/${siteId}/accommodation`,
      );
      dispatch(getAccommodationSuccess(languageId, data));
    } catch (error) {
      dispatch(
        showAlert("Beim Laden der Betriebsdaten ist ein Fehler aufgetreten!"),
      );
      throw error;
    }
  };

const getAccommodationStart = (
  languageId: Language,
): GetAccommodationStart => ({ type: "GET_ACCOMMODATION_START", languageId });

export const getAccommodationSuccess = (
  languageId: Language,
  accommodation: Accommodation,
): GetAccommodationSuccess => ({
  type: "GET_ACCOMMODATION_SUCCESS",
  languageId,
  accommodation,
});
